import { useState } from 'react';
import './AddDoseFab.css';

// Listed top to bottom; G sits closest to the main button.
const OPTIONS = ['V', 'K', 'G'];

const AddDoseFab = ({ className = '', onAddDose, onAddLetter }) => {
    const [open, setOpen] = useState(false);

    const handleOption = (e, option) => {
        e.stopPropagation();
        setOpen(false);
        if (option === 'G') onAddDose();
        else onAddLetter(option);
    };

    const handleToggle = (e) => {
        e.stopPropagation();
        setOpen(o => !o);
    };

    return (
        <div className={`add-dose-fab ${open ? 'open' : ''} ${className}`}>
            {OPTIONS.map((option, index) => (
                <button
                    key={option}
                    type="button"
                    className={`add-dose-option ${option === 'G' ? 'primary' : ''}`}
                    style={{ '--offset': OPTIONS.length - index }}
                    tabIndex={open ? 0 : -1}
                    aria-hidden={!open}
                    onClick={(e) => handleOption(e, option)}
                >
                    {option}
                </button>
            ))}
            <button
                type="button"
                className="add-new-dose"
                aria-label={open ? 'Close add dose menu' : 'Add dose'}
                aria-expanded={open}
                onClick={handleToggle}
            >
                <span className="plus">+</span>
            </button>
        </div>
    );
};

export default AddDoseFab;
